import Vue from 'vue';
import { SectionsProvider } from '../providers/sections.provider';
import Content from '../models/content.model';
import KEYS from '@/values/keys';
import Course from '../models/course.model';
import { User } from '@/core/models/user.model';
import {WidgetTeacherSectionItem} from '@/homework/models/widget-teacher-section-item.model';
import { COMPONENT_TYPE, SECTION_OPTION_MODE } from '@/courses/values/courses.values';
import { Section } from '@/courses/models/section.model';
import { SectionProvider } from '@/sections/providers/section.provider';

class CourseMutations {

  setCourseInfo(state, courseInfo) {
    let data = {state , courseId: courseInfo.id , classId: courseInfo.classId }
    let ICourse = SectionsProvider.getCourseIndex(data);
    if(ICourse === -1) state.courses.content.push(courseInfo);
    else {
      state.courses.content.splice(ICourse , 1 , courseInfo);
    }
  }
  
  /* Deprecated */
  setStudentsInCourse(state, { students, course, page }) {
    let i = state.courses.content.findIndex(c => c.id == course.id);
    if(page == 0) {
      state.courses.content[i].users = [];
    }
    students.forEach((s) => {
      state.courses.content[i].users.push(new User(s));
    });
  }

  /* Deprecated */
  setCourseContent(state, { data , courseId , classId = null}) {
    let materialParams = {state , materials: data.materials , courseId , classId};
    let sections = data.sections ? data.sections : [];
    state.materials = data.materials ? SectionsProvider.setCourseMaterials(materialParams) : [];
    Vue.set(state, 'sections', SectionsProvider.setCourseContent({parentSections: sections, sections , courseId}));
  }

  setContentForCourse(state, { data, courseId, classId }) {
    const sections = [ ...data.sections ]
      .map(s => ({ ...s, parentId: null }));
    
    if(data.funSections) {
      sections.push(data.funSections);
    }
    
    if(data.fillerSections) {
      sections.push(data.fillerSections);
    }

    if(data.additionalSections) {
      sections.push(data.additionalSections);
    }

    let materialParams = {state , materials: data.materials , courseId , classId};
    let sectionParams = { parentSections: sections, sections, courseId,  classId };
    let projectParams = {projects: data.projects ? data.projects : [], courseId, classId};
    let materials = data.materials ? SectionsProvider.setCourseMaterials(materialParams) : {};
    let Icourse  = SectionsProvider.getCourseIndex({state , courseId , classId});
    let decksParam = { parentSections: sections, sections: [data.deckLibrary], courseId,  classId };
    if (!state.courses.content[Icourse].eduacComponents) {
      state.courses.content[Icourse].eduacComponents = data.components;
    }
    
    state.courses.content[Icourse].sections = SectionsProvider.setCourseContent(sectionParams);
    state.courses.content[Icourse].materials = materials;
    state.courses.content[Icourse].projects =  SectionsProvider.setCourseProjects(projectParams);
    
    let decks = SectionsProvider.setCourseContent(decksParam);
    state.courses.content[Icourse].deckLibrary = decks ? decks[0] : {};
    let materialsList = materials.materials.concat(materials.nodes);
    let materialsListParams = {materialsList, courseId , classId}
    state.courses.content[Icourse].materialsList = SectionsProvider.setMaterialsListContent(materialsListParams);
    state.courses.content[Icourse].showTeacherOnlyMessage = data.showTeacherOnlyMessage;

    if(data.schoolDay) {
      state.courses.content[Icourse].schoolCalendar = data.schoolDay;
    }

  }

  setGradingDetailsForCourse(state, {gradingDetails, courseId , classId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let sections = course.sections;
    gradingDetails.forEach(el => {
      sections = SectionsProvider.addGradingDetails({sections, detail: el , courseId , classId});
    })
    Vue.set(state.courses.content[Icourse], 'sections', sections);
  }

  updateOrderSections(state, { sections, sectionId = null, courseId, classId }) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course: Course = state.courses.content[Icourse];
    let newSections = [];

    if (!sectionId) {
      const funAndFiller = SectionProvider.getContentSections(course.sections);
      newSections = [ ...sections, ...funAndFiller ];
    } else {
      newSections = SectionsProvider.assignSectionsToSection(course.sections, sections, sectionId);
    }

    course.sections = newSections;




  }

  createSection(state, {section, parentID, copiedSectionId , courseId , classId}) {
    let sectionAdded = {
      ...section,
      classId,
      courseId,
      sectionId: section.id,
      sections: section.sections ? section.sections : [] 
    };
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    if(parentID) {
      let sections = [];
      if(copiedSectionId)
        sections = SectionsProvider.addSection(course.sections, sectionAdded, parentID, copiedSectionId);
      else
        sections = SectionsProvider.addSection(course.sections, sectionAdded, parentID);
      state.courses.content[Icourse].sections = sections;
    } else {
      course.sections.push(sectionAdded);
    }
  }

  updateSection(state, {section, courseId , classId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let sections = SectionsProvider.updateSection({sections: course.sections, section , courseId , classId});
    let projects = SectionsProvider.updateSectionProject({projects: course.projects, section , courseId , classId});
    Vue.set(state.courses.content[Icourse], 'sections', sections);
    Vue.set(state.courses.content[Icourse], 'projects', projects);
    state.sectionToEdit = section;
  }

  resetSectionToEdit(state) {
    state.sectionToEdit = null;
  }

  /* Deprecated */
  createObject(state, {section, parentId}) {
    section.sectionId = section.id;
    section.sections = [];
    Vue.set(state, 'sections', SectionsProvider.addSection(state.sections, section, parentId));
  }

  removeSection(state, { sectionId , courseId , classId }) {

    /* Remove section from the tree */
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let sections = SectionsProvider.removeSection(course.sections, sectionId);
    let projects = SectionsProvider.removeSectionProject(course.projects, sectionId);
    course.sections = sections;
    course.projects = projects;

    /* Validate if the section was selected */
    if(course.component.section) {
      if(course.component.section.sectionId == sectionId) {
        course.component.section = null;
        course.component.edition = false;
        course.component.name = COMPONENT_TYPE.LESSON_CREATOR.code;
      }
    }
  }
  
  setCourses(state, coursesList) {
    let courses = coursesList.map(c => {
      let course = new Course(c.content, c.classId, c.meetingId, c.className); 
      return course;
    });
    state.courses.content = courses;
    state.presentationCourseSelected = courses.length > 0 ? courses[0].id : 0;
  }

  setPreviewSelected(state, {section, material, project, courseId , classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId})
    let course = state.courses.content[ICourse]
    if (section || material) state.hasObjectSelected = true;
    Vue.set(course.viewer, 'sectionSelected', section);
    Vue.set(course.viewer, 'materialSelected', material);
    Vue.set(course.viewer, 'projectSelected', project);
    Vue.set(course, 'sectionCompletedTask', null);
  }

  setShowSectionPersonCourseViewer(state, value){
    state.showSectionPersonCourseViewer = value;
  }

  setCompletedTaskBySection(state, {persons, section}) {
    let ICourse = SectionsProvider.getCourseIndex({state, courseId: section.courseId, classId: section.classId})
    let course = state.courses.content[ICourse]
    let personsList = course.sectionCompletedTask && persons.number !== 0?
        course.sectionCompletedTask.users.content:[];
    persons.content.forEach(h => {
      personsList.push(new WidgetTeacherSectionItem(
          {
            ...h,
            courseId: section.courseId,
            sectionListId: section.sectionId,
            classId: section.classId
          }
      ));
    });
    section.users = {
      content: personsList,
      page: persons.number,
      more: !persons.last
    };
    Vue.set(course, 'sectionCompletedTask', section);
  }

  setComponentSelected(state , {courseId , classId , componentInfo}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    Vue.set(course, 'component', componentInfo);
  }

  /* Course Materials */
  setCourseMaterial(state , {material , courseId, classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let materials = SectionsProvider.addCourseMaterial({state , courseId ,
    materials: course.materials , material, classId});
    course.materials = materials;
    course.materialsList = SectionsProvider.addCourseMaterialList({state , courseId ,
      materialsList: course.materialsList , material, classId});  
  }

  updateCourseMaterial(state , {material, courseId , classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let data = {state , materials: course.materials , material , courseId , classId};
    let materials = SectionsProvider.updateCourseMaterial(data);
    course.materials = materials;
    let dataList = {state , materialsList: course.materialsList , material , courseId , classId};
    let materialsList = SectionsProvider.updateCourseMaterialList(dataList);
    course.materialsList = materialsList;
    course.showTeacherOnlyMessage = material.showTeacherOnlyMessage;
  }

  removeCourseMaterial(state, {materialId , relatedCourseMaterials , courseId , classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let sections = course.sections;
    let projects = course.projects;
    let materials = SectionsProvider.removeCourseMaterial(course.materials, materialId);
    let materialsList = SectionsProvider.removeCourseMaterialList(course.materialsList, materialId);
    if(relatedCourseMaterials) {
      let sectionIds = SectionsProvider.getSectionsIdsByMaterialId(sections , materialId);
      let projectIds = SectionsProvider.getProjectsIdsByMaterialId(projects , materialId);
      sectionIds.forEach(sectionId => {
        sections = SectionsProvider.removeSection(sections, sectionId);
      });
      projectIds.forEach(projectId => {
        projects = SectionsProvider.removeProject(projects, projectId);
      });
      course.sections = sections;
      course.projects = projects;
    }
    course.materials = materials;
    course.materialsList = materialsList; 
  }

  setCourseMaterialSection(state , {section, courseId , classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let materials = SectionsProvider.addCourseMaterialSection(
      {materials : course.materials , section , courseId, classId});
    course.materials = materials;
    let materialsList = SectionsProvider.addCourseMaterialListSection(
      {materialsList : course.materialsList , section , courseId, classId});
    course.materialsList = materialsList;
  }

  updateMaterialSectionName(state , {name, materialSectionId , courseId , classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let section = SectionsProvider.getSectionMaterialFromId(course.materials.nodes , materialSectionId);
    section.sectionName = name;
    let sectionMaterialsList = SectionsProvider.getSectionMaterialListFromId(course.materialsList , materialSectionId);
    sectionMaterialsList.sectionName = name;
  }
  
  /* Deprecated */
  updateMaterialSection(state, {section,material}) {
    let newSection;
    if(material){
      newSection = SectionsProvider.getSectionMaterialFromId(state.materials.nodes,material.parentId);
      if(newSection){
        newSection.materials = newSection.materials.map(m=>{
          if(m.relatedContentId == material.materialId){
            m.data.teacherOnly = material.teacherOnly;
          }
          return m;
        });
        Vue.set(state.materials, 'nodes', SectionsProvider.updateMaterialSection(state.materials.nodes, newSection));
      }
    }
    else if(section){
      newSection = SectionsProvider.getSectionMaterialFromId(state.materials.nodes,section.sectionId);
      if(newSection){
        newSection.teacherOnly = section.teacherOnly;
      Vue.set(state.materials, 'nodes', SectionsProvider.updateMaterialSection(state.materials.nodes, newSection));
      }
    }
  }

  removeCourseMaterialSection(state , {sectionId, courseId, classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let materials = SectionsProvider.removeCourseMaterialSection(course.materials , sectionId);
    course.materials = materials;
    let materialsList = SectionsProvider.removeCourseMaterialListSection(course.materialsList , sectionId);
    course.materialsList = materialsList;
  }

  setTeacherOnlySection(state, { courseId , classId ,sectionId, teacherOnly}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let section = SectionsProvider.getSectionByID(course.sections, sectionId);
    let sectionToUpdate = { ...section, teacherOnly };
    let sectionInfo = {sections: course.sections , section: sectionToUpdate,
    courseId, classId}
    course.sections =  SectionsProvider.updateSection(sectionInfo);
  }

  /* Subject Projects */
  /* Deprecated */
  setProjectSection(state , {project, courseId, classId}) {
    let ICourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[ICourse];
    let projects = SectionsProvider.addProjectSection({
      projects: course.projects, 
      project 
    });
    course.projects = projects;
  }

  createProject(state, {project, parentId, courseId , classId}) {
    let projectAdded = {
      ...project,
      projects: project.projects ? project.projects : [] 
    };
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    if(parentId) {
      let projects = [];
      projects = SectionsProvider.addProjectSection({projects: course.projects, project: projectAdded, parentId});
      state.courses.content[Icourse].projects = projects;
    } else {
      course.projects.push(projectAdded);
    }
  }

  updateProject(state, {project, courseId , classId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let projects = SectionsProvider.updateProject({projects: course.projects, project , courseId , classId});
    Vue.set(state.courses.content[Icourse], 'projects', projects);
  }

  removeProject(state, { projectId , courseId , classId }) {

    /* Remove section from the tree */
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let projects = SectionsProvider.removeProject(course.projects, projectId);
    course.projects = projects;

    /* Validate if the section was selected */
    if(course.component.section) {
      if(course.component.section.sectionId == projectId) {
        course.component.section = null;
        course.component.edition = false;
        course.component.name = COMPONENT_TYPE.PROJECT_CREATOR.code;
      }
    }
  }

  updateOrderProjects(state, { projects, projectId = null , courseId , classId}) {
    let Icourse = SectionsProvider.getCourseIndex({state, courseId , classId});
    let course = state.courses.content[Icourse];
    let newProjects = [];
    if(!projectId) {
      newProjects = projects;
    } else {
      newProjects = SectionsProvider.assignProjectsToSection(course.projects, projects, projectId);
    }
    course.projects = newProjects;
  }

  saveProjectFiles(state, { projectId, sectionsAdded, courseId , classId, removeSections }) {
    let Icourse = SectionsProvider.getCourseIndex({state, courseId , classId});
    let course = state.courses.content[Icourse];
    let project = SectionsProvider.getProjectByID(course.projects, projectId);
    let projectsAdded = sectionsAdded.map(item => {
      return {
        ...item, 
        courseId, 
        classId, 
        section: SectionsProvider.getSectionByID(course.sections, item.section.id),
        projects: []
      }
    })
    project.projects = project.projects.concat(projectsAdded)
    project.projects = removeSections.length > 0 ? project.projects.filter(item => !removeSections.includes(item.section.id)) : project.projects;
  }
  /* End Subject Projects */

  /* this was Used for import content*/ 
  /* Deprecated */
  importCourseMaterial(state, courseMaterial) {    
    courseMaterial.relatedContentResponse.imported = true;
    state.materials.push({
      data: new Content({
          ...courseMaterial.relatedContentResponse, 
          type: KEYS.CONTENT_TYPE.BK
        },
        state.url
      ),
      relatedContentId: courseMaterial.id,
      sectionParentId: courseMaterial.sectionMaterialId ? courseMaterial.sectionMaterialId : null
    });    
  }

  setCourseMode(state, { courseId, mode }) {
    let i = state.courses.content.findIndex(c => c.id == courseId);
    state.courses.content[i].mode = mode;
  }

  setMovingObject(state, value) {
    state.movingObject = value;
  }

  setPresentationTeacherMode(state, data) {
    state.isPresentationTeacherMode = data.isPresentationTeacherMode;
  }

  setPresentationStudentMode(state, data) {
    state.isPresentationStudentMode = data.isPresentationStudentMode;
  }

  updatePresentationCourseSelected(state, data) {
    state.presentationCourseSelected = data.presentationCourseSelected;
  }

  setPresentationCourses(state, { coursesList, classId }) {
    let courses = coursesList.map(item => {
      let course = new Course(item, classId); 
      return course;
    });
    state.courses.content = courses;
    state.presentationCourseSelected = courses.length > 0 ? courses[0].id : 0;
  }

  setZoomObject(state, value) {
    state.zoomObject = value;
  }

  isSplitHorizontal(state, value) {
    state.isSplitHorizontal = value;
  }

  isSplitVertical(state, value) {
    state.isSplitVertical = value;
  }

  setPdfLoading(state, value) {
    state.pdfLoading = value;
  }

  setImagesLoading(state, value) {
    state.imagesLoading = value;
  }

  setVideoLoading(state, value) {  
    state.videoLoading = value;
  }

  setIsBoardSectionHomework(state, value) {
    state.isBoardSectionHomework = value;
  }
  
  revertSectionMoved(state, data: { section: Section, nextIndex: number, nextParentId: number, currentParentId: number }) {
    const { section, nextIndex, nextParentId, currentParentId } = data;
    const Icourse = SectionsProvider.getCourseIndex({state, courseId: section.courseId, classId: section.classId });
    const course = state.courses.content[Icourse];

    if (currentParentId) {
      const currentParent = SectionsProvider.getSectionByID(course.sections, currentParentId);
  
      if (currentParent) {

        if (!currentParent.sections) {
          currentParent.sections = [];
        }

        const i = currentParent.sections.findIndex(s => s.id === section.id);
        if (i !== -1) {
          currentParent.sections.splice(i, 1);
        }
      }
    } else {
      const j = course.sections.findIndex(s => s.id === section.id);
      if (j !== -1) {
        course.sections.splice(j, 1);
      }
    }

    if (nextParentId) {
      const nextParent = SectionsProvider.getSectionByID(course.sections, nextParentId);
      if (nextParent) {

        if (!nextParent.sections) {
          nextParent.sections = [];
        }

        nextParent.sections.splice(nextIndex, 0, section);
      }
    } else {
      course.sections.splice(nextIndex, 0, section);
    }
  }

  removeSectionFromParent(state, data) {
    const { section, parentId } = data;

    let i = SectionsProvider.getCourseIndex({state, courseId: section.courseId, classId: section.classId });
    let sections: Section[] = state.courses.content[i].sections;

    if (parentId) {
      const parent = SectionsProvider.getSectionByID(sections, parentId);

      if (parent) {
        sections = parent.sections;
      }
    }

    const indexToRemove = sections.findIndex(s => s.id === section.id);
    sections.splice(indexToRemove, 1);
  }

  addComponent(state, data) {
    const Icourse = SectionsProvider.getCourseIndex({state, courseId: data.courseId, classId: data.classId });
    const course = state.courses.content[Icourse];
    course.eduacComponents.push(data.data);
  }

  setComponent(state, data) {
    const Icourse = SectionsProvider.getCourseIndex({state, courseId: data.courseId, classId: data.classId });
    const course = state.courses.content[Icourse];
    let componentIndex = course.eduacComponents.findIndex(c => c.id == data.data.id);
    course.eduacComponents[componentIndex] = data.data;
  }

  deleteComponent(state, data) {
    const Icourse = SectionsProvider.getCourseIndex({state, courseId: data.courseId, classId: data.classId });
    const course = state.courses.content[Icourse];
    let componentIndex = course.eduacComponents.findIndex(c => c.id == data.componentId);
    const deleted = course.eduacComponents.splice(componentIndex, 1);
    if (deleted[0].id === state.eduacComponentSelected.id) {
      state.eduacComponentSelected = course.eduacComponents.find(c => c.mandatory);
    }
  }
  
  /* Decks */
  createDeck(state, {deckSection, courseId, classId}) {
    let deckAdded = {
      ...deckSection,
      classId,
      courseId,
      sectionId: deckSection.id,
      text: deckSection.cardType,
      component: deckSection.component,
      sections: deckSection.sections ? deckSection.sections : []
    };
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    course.deckLibrary.sections.push(deckAdded);
  }

  updateDeck(state, {deckSection, courseId , classId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];  
    let sectionDeck = course.deckLibrary.sections.find(s => {
      return s.sectionId === deckSection.id;
    });
    if(sectionDeck){
      sectionDeck.name = deckSection.name;
      sectionDeck.component = deckSection.component
    }
    course.sections = SectionsProvider.updateSubdeckObjectsByDeck(course.sections, sectionDeck)
  }

  removeDeck(state, { deckSectionId , courseId , classId }) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let decks = SectionsProvider.removeSection(course.deckLibrary.sections, deckSectionId);
    course.deckLibrary.sections = decks;

    /* Validate if the section was selected */
    if(course.component.section) {
      if(course.component.section.sectionId == deckSectionId) {
        course.component.section = null;
        course.component.edition = false;
        course.component.name = COMPONENT_TYPE.DECK_CREATOR.code;
      }
    }
  }

  refreshDeck(state, { deckSection , courseId , classId }) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let targetDeck = course.deckLibrary.sections.find(s => {
      return s.sectionId === deckSection.id;
    });
    if(targetDeck){
      targetDeck.sections = deckSection.sections;
    }
  }

  createCard(state, {cardSection, courseId, classId, deckSectionId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let deck = course.deckLibrary.sections.find(s => {
      return s.sectionId === deckSectionId;
    });
    if(deck){
      deck.sections.push(cardSection);
    }
  }

  updateCard(state, {cardSection, courseId, classId, deckSectionId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let deck = course.deckLibrary.sections.find(s => {
      return s.sectionId === deckSectionId;
    });
    if(deck){
      let current = deck.sections.find(s => {
        return s.sectionId === cardSection.sectionId;
      });
      current.text = cardSection.text;
      current.sections = cardSection.sections;
      current.name = cardSection.name;
    }
  }

  removeCard(state, {cardSectionId, courseId, classId, deckSectionId}) {
    let Icourse = SectionsProvider.getCourseIndex({state , courseId , classId});
    let course = state.courses.content[Icourse];
    let deck = course.deckLibrary.sections.find(s => {
      return s.sectionId === deckSectionId;
    });
    if(deck){
      let cards = SectionsProvider.removeSection(deck.sections, cardSectionId);
      deck.sections = cards;
    }
  }

  setCurrentCardInfo(state, value) {
    state.currentCardInfo = value;
  }

  setCurrentMenuOptions(state, {key, value} : {key: string, value: any}) {    
    if(Object.keys(value).length === 0) {
      delete state.currentMenuOptions[key];
    } else {
      let mergedObject = state.currentMenuOptions[key] ? Object.assign(state.currentMenuOptions[key], value) :  value;
      Vue.set(state.currentMenuOptions, key, mergedObject);
    }
  }

  setEduacComponentSelected(state, value) {
    state.eduacComponentSelected = value;
  }

  /* Initial State */
  public initCourseState(state) {
    state.coursesAlreadyLoad = false;
    state.sectionOpenedMode = SECTION_OPTION_MODE.COMMON;
    state.hasObjectSelected = false;
    state.movingObject = false;
    state.courses = {
      content: [],
      more: false,
      page: 0,
      pageSize: 300
    }
    state.isPresentationTeacherMode = false;
    state.isPresentationStudentMode = false;
    state.presentationCourseSelected = 0;
    state.zoomObject = true;
    state.isSplitHorizontal = false;
    state.isSplitVertical = false;
    state.pdfLoading = true;
    state.showSectionPersonCourseViewer = false;
    state.imagesLoading = true;
    state.videoLoading = true;
    state.isBoardSectionHomework = false;
    state.currentCardInfo = {
      isFrontSide: true,
      card: {},
      index: 0
    }
    state.currentMenuOptions = {};
  }

  public initTeacherPortalState(state) {
    state.meetings = [];
    state.courses = [];
    state.course = {};
    state.currentLessons = [];
    state.usersOrganization = [];
    state.homeworks = [];
    state.tasks = [];
    state.userId = null;
    state.sections = [];
    state.coursesAlreadyLoad = false;
    state.page = null;
    state.widgetFullScreen = null;
  }

}

export default new CourseMutations();